import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserSession } from '../auth/authentication.interfaces';
import { PostLoginProcessor } from '../auth/post-login-processor.interface';
import { UserApprovalStatus } from '../auth/user-approval-status.enum';

/**
 * This class is used for logging in the AAD login flow,
 * after a login is successful a request is sent to the
 * backend to process the user in our system.
 */
export class AADPostLoginProcessor implements PostLoginProcessor {
	constructor(private http: HttpClient) {}

	execute(userSession: UserSession): Observable<UserSession> {
		// Get user status
		return this.http
			.get(userSession.backend.baseUrl + 'userstatus/', {
				headers: new HttpHeaders().set('Authorization', 'Bearer ' + userSession.backend.token),
			})
			.pipe(
				map((userData: UserApproval) => {
					userSession.user.isSuperAdmin = userData.user.isSuperAdmin;
					userSession.user.email = userData.user.email;
					userSession.user.userId = userData.user.id;
					userSession.user.displayName = userData.user.fullName;
					userSession.user.userName = userData.user.fullName;
					userSession.user.userStatus = userData.userApproval.status;

					return userSession;
				})
			);
	}
}

/**
 * Class returned when checking the user status
 * the authenticated user.
 */
class UserApproval {
	user: {
		isSuperAdmin: boolean;
		email: string;
		id: number;
		fullName: string;
	};
	userApproval: {
		status: UserApprovalStatus;
	};
}
